<template>
  <div class="container">
    <div class="row">
      <div v-if="loading">
        <loader></loader>
      </div>
      <div v-else>
        <h1>Tipo de Requisição</h1>
        <hr>
        <div class="form">
          <div class="form-group">
            <label for="name">Nome</label>
            <input id="name" type="text" v-model="requestType.name" class="form-control" />
          </div>
          <div class="form-group">
            <label for="description">Descrição</label>
            <textarea id="description" type="text" v-model="requestType.description" class="form-control" />
          </div>
          <div class="form-group">
            <label for="active">Ativo</label>
            <input id="active" type="checkbox" v-model="requestType.active" />
          </div>
          <div v-if='requestType.owner && requestType.owner.username' class="form-group">
            <label for="owner">Proprietário</label>
            <input id="owner" type="text" disabled=true v-model="requestType.owner.username" class="form-control" />
          </div>
        </div>
        <hr>
        <button id="btn-save" class="btn btn-primary" v-on:click="save">
          Salvar
        </button>
        <button id="btn-remove" v-if="requestType.objectId" class="btn btn-danger" v-on:click="remove">
          Remover
        </button>
        <button id="btn-cancel" class="btn btn-default" v-on:click="cancel">
          Cancelar
        </button>
      </div>
      <br>
      <form-section-list v-bind:reqType='requestType.objectId' v-if='requestType.objectId'></form-section-list>
    </div>

  </div>
</template>

<script>
  import {
    Parse,
    miniToastr
  } from '../Global'
  import FormSectionList from './FormSectionList'
  import Loader from './util/Loader'
  import { handleParseError } from './util/ErrorHandling'

  var RequestType = Parse.Object.extend('RequestType')

  export default {
    components: {
      Loader,
      FormSectionList
    },
    data () {
      return {
        requestType: {
          owner: {}
        },
        requestTypeParse: {},
        name: '',
        loading: false
      }
    },
    mounted () {
      let id = this.$route.params.id
      if (id) {
        this.getRequestType(id)
      } else {
        this.requestTypeParse = new RequestType()
      }
    },
    methods: {
      getRequestType (id) {
        let self = this
        self.loading = true
        let params = { requestId: id }
        Parse.Cloud.run('getRequestType', params).then(result => {
          self.requestTypeParse = result
          self.requestType = result.toJSON()
          self.loading = false
        }).fail(error => {
          handleParseError(self, error)
          self.loading = false
        })
      },
      save () {
        let self = this
        let editing = self.requestTypeParse.id !== undefined
        self.loading = true
        let params = { requestType: self.requestType }
        Parse.Cloud.run('saveRequestType', params).then(obj => {
          self.loading = false
          miniToastr.success('Salvo com sucesso')
          if (editing) {
            self.$router.push('/requestTypes')
          } else {
            self.getRequestType(obj.id)
            self.$router.replace({name: 'RequestTypeDetail', params: {id: obj.id}})
          }
        }).fail(error => {
          handleParseError(self, error)
          self.loading = false
        })
      },
      remove () {
        if (confirm('Deseja realmente remover o Tipo de Requisição e todos os seus Campos?')) {
          let self = this
          self.loading = true
          let params = { requestId: self.requestType.objectId }
          Parse.Cloud.run('removeRequestType', params).then(obj => {
            self.loading = false
            miniToastr.success('Excluído com sucesso')
            self.$router.go('-1')
          }).fail(error => {
            self.loading = false
            handleParseError(self, error)
          })
        }
      },
      cancel () {
        this.$router.go(-1)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// RequestTypeDetail.vue?9b8a3672